import { render, staticRenderFns } from "./AfiliadosCadastro.vue?vue&type=template&id=bd6f01e4&scoped=true&"
import script from "./AfiliadosCadastro.vue?vue&type=script&lang=js&"
export * from "./AfiliadosCadastro.vue?vue&type=script&lang=js&"
import style0 from "./AfiliadosCadastro.vue?vue&type=style&index=0&id=bd6f01e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f01e4",
  null
  
)

export default component.exports